export default [
    {
        key: 'food',
        text: {
            nl: 'food',
            en: 'Food',
        },
    },
    {
        key: 'bio',
        text: {
            nl: 'bio',
            en: 'bio',
        },
    },
    {
        key: 'energy',
        text: {
            nl: 'energy',
            en: 'energy',
        },
    },
    {
        key: 'hightech',
        text: {
            nl: 'hightech',
            en: 'hightech',
        },
    },
    {
        key: 'chemical',
        text: {
            nl: 'chemical',
            en: 'chemical',
        },
    },
    {
        key: 'softtech',
        text: {
            nl: 'softtech',
            en: 'softtech',
        },
    },
    {
        key: 'transport',
        text: {
            nl: 'transport',
            en: 'transport',
        },
    },
    {
        key: 'lifescience',
        text: {
            nl: 'lifescience',
            en: 'lifescience',
        },
    },
    {
        key: 'medtech',
        text: {
            nl: 'medtech',
            en: 'medtech',
        },
    },
    {
        key: 'fintech',
        text: {
            nl: 'fintech',
            en: 'fintech',
        },
    },
    {
        key: 'other',
        text: {
            nl: 'anders',
            en: 'other',
        },
    },
]
